/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SudoDeactivateUserMutationInput = {
    clientMutationId?: string | null | undefined;
    email: string;
};
export type SudoDeactivateUserMutationVariables = {
    input: SudoDeactivateUserMutationInput;
};
export type SudoDeactivateUserMutationResponse = {
    readonly sudoDeactivateUser: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SudoDeactivateUserMutation = {
    readonly response: SudoDeactivateUserMutationResponse;
    readonly variables: SudoDeactivateUserMutationVariables;
};



/*
mutation SudoDeactivateUserMutation(
  $input: SudoDeactivateUserMutationInput!
) {
  sudoDeactivateUser(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SudoDeactivateUserMutationPayload",
            "kind": "LinkedField",
            "name": "sudoDeactivateUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SudoDeactivateUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SudoDeactivateUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "64b4d184bcfafd1c375234da54102803",
            "id": null,
            "metadata": {},
            "name": "SudoDeactivateUserMutation",
            "operationKind": "mutation",
            "text": "mutation SudoDeactivateUserMutation(\n  $input: SudoDeactivateUserMutationInput!\n) {\n  sudoDeactivateUser(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b7123a2ab07c06b82c8b1a00d0012794';
export default node;
